var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFounders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16V16.5H2H8.68688L9.64161 17.3254L9.64175 17.3255L9.84343 17.5H0.5V15.5C0.5 14.9425 0.772534 14.4151 1.30633 13.9152C1.84351 13.4121 2.61297 12.9702 3.51054 12.605C5.30635 11.8744 7.4922 11.5 9 11.5C10.1643 11.5 11.7398 11.7244 13.2289 12.1667L12.8385 13.0942C11.6597 12.7452 10.3047 12.5 9 12.5C7.28055 12.5 5.46918 12.9238 4.08553 13.4576C3.39395 13.7244 2.78898 14.0264 2.34702 14.3311C2.12714 14.4827 1.93055 14.6465 1.78364 14.8206C1.64459 14.9854 1.5 15.2186 1.5 15.5V16ZM14.7262 15.6408L15.0267 15.6151L15.1442 15.3372L16.0125 13.2826L16.8815 15.3319L16.9991 15.6092L17.2992 15.6349L19.5229 15.825L17.8369 17.284L17.6088 17.4814L17.677 17.7752L18.1848 19.961L16.2699 18.8062L16.0119 18.6506L15.7537 18.8061L13.8394 19.9593L14.3463 17.7834L14.4148 17.4895L14.1867 17.292L12.4999 15.831L14.7262 15.6408ZM5.5 4C5.5 2.07885 7.07885 0.5 9 0.5C10.9212 0.5 12.5 2.07885 12.5 4C12.5 5.92115 10.9212 7.5 9 7.5C7.07885 7.5 5.5 5.92115 5.5 4ZM11.5 4C11.5 2.60744 10.3926 1.5 9 1.5C7.60744 1.5 6.5 2.60744 6.5 4C6.5 5.39256 7.60744 6.5 9 6.5C10.3926 6.5 11.5 5.39256 11.5 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounders);
export default __webpack_public_path__ + "static/media/founders.44b5924e2edc0a48b188367159d12599.svg";
export { ForwardRef as ReactComponent };